import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Classification_Search_Fields: {[id: string]: ISearchProviderField}  = {
    WB_CLASSIFICATION_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'Wb Id',
            columnResourceName: 'colwbId',
            alignment: HorizAlignment.Left},
        domainOptions: {}
    },
    CLASSIFICATION_ID:         {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Id',
            columnResourceName: 'colId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 50}},
    CLASSIFICATION_NAME:       {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Name',
            columnResourceName: 'colName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 256}
    },
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
};

const ClassificationSearchProviderBasic: ISearchProvider = {

    keyFields: {
        id:    'WB_CLASSIFICATION_ID',
        id_ui: 'CLASSIFICATION_ID',
        name:  'CLASSIFICATION_NAME'
    },

    searchProviderFields: vUI_Classification_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Classification_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[])=> {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                });
        })
    }
};

const ClassificationSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5SourceId: "ClassificationSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id',        searchProviderFieldId: 'CLASSIFICATION_ID', renderOptions: {}},
        {profileFilterName: 'Name',      searchProviderFieldId: 'CLASSIFICATION_NAME', renderOptions: {}},

    ], //ISearchFields
    profileDisplayFields: [
        'CLASSIFICATION_ID', 'CLASSIFICATION_NAME', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ],

    profileSearchProvider: ClassificationSearchProviderBasic,

    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const ClassificationSearch: ISearch = {
    searchName: "Find Classification Point",
    renderOptions: {ui5ResourceId: "ClassificationSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [ClassificationSearchProfileByName]
};

PAEnvironment
    .registerBusinessObjectSearch(
        "ClassificationBO",
        "Classification", ClassificationSearch, "Classification Search")

export {ClassificationSearch}
